/**
 * @generated SignedSource<<69a72ae4bbfe60ad94ec9ebe766620dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postHeaderFragment$data = {
  readonly author: {
    readonly avatarFallback: string;
    readonly badges: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"memberBadgeFragment">;
    }>;
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly photo: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly username: string | null | undefined;
  } | null | undefined;
  readonly club: {
    readonly id: string;
    readonly slug: string;
  };
  readonly createdAt: any;
  readonly id: string;
  readonly pinned: boolean;
  readonly pinnedUniversal: boolean;
  readonly slug: string;
  readonly space: {
    readonly icon: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly slug: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"postMoveDialogQuery">;
  readonly " $fragmentType": "postHeaderFragment";
};
export type postHeaderFragment$key = {
  readonly " $data"?: postHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postHeaderFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "club"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "postHeaderFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarFallback",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "club",
              "variableName": "club"
            }
          ],
          "concreteType": "Badge",
          "kind": "LinkedField",
          "name": "badges",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "memberBadgeFragment"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageFile",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "signedUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pinned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pinnedUniversal",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postMoveDialogQuery"
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "24f0bad3895ad1789af9d0952346dc54";

export default node;
